import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" {...props}>
      <path
        fill="var(--svg-color-main, black)"
        d="M13.285 12.915v1.714H.857l1.691-7.385A1.524 1.524 0 0 1 4.033 6.06l9.252-.002V8.63h4.541c.938 0 1.793.537 2.2 1.381l1.4 2.904z"
        opacity="0.4"
      ></path>
      <path
        fill="var(--svg-color-main, black)"
        fillRule="evenodd"
        d="M10.77 7.394a1.716 1.716 0 0 1 1.674-1.335h1.206c.982 0 1.778.795 1.778 1.777v.792h-2.923v.001h.352v4.286h8.572A2.57 2.57 0 0 1 24 15.487v2.57a2.572 2.572 0 0 1-4.996.858h-2.008a2.573 2.573 0 0 1-4.85 0H5.854a2.572 2.572 0 0 1-4.997-.857v-3.429h9.837v-.001H9.127zM3.429 18.976a.918.918 0 1 0 0-1.836.918.918 0 0 0 0 1.836m12.06-.918a.918.918 0 1 1-1.836 0 .918.918 0 0 1 1.836 0"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}
